import React, { useRef, useState } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "../../css/react-phone-input-2/high-res-flags.css";
import "../../css/react-phone-input-2/material.css";

const TAG = "ModPhoneInput";

interface IProps {
    value: string;
    disabled?: boolean;
    onChange?: (phoneNumber: string) => void; 
}

const useStyles = makeStyles({
    root: {},
    phoneHint: {
      userSelect: "contain",
    },
  });

const ModPhoneInput = (props: IProps) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    const phoneInputProps: any = null;
    const inputRef = useRef();
    
    const [dialCodeLength, setDialCodeLength] = useState(2);

    return (
        <Box>
              <PhoneInput
                ref={inputRef}
                {...phoneInputProps}
                inputStyle={{
                  width: "100%",
                  height: "40px",
                }}
                inputProps={{
                  required: true,
                }}
                placeholder={""}
                specialLabel={t("makeAppt.phoneNum")}
                country={"my"}
                disabled={props.disabled}
                prefix={""}
                autoFormat={true}
                countryCodeEditable={false}
                value={props.value}
                masks={{ my: "............" }}
                onChange={(_phoneNum: string, data: any) => {
                  setDialCodeLength(data.dialCode.length);

                  if (props.onChange) {
                    props.onChange(_phoneNum);
                  }
                }}
              />
              <Box
                position="relative"
                className={classes.phoneHint}
                onClick={() => {
                  (inputRef.current as any)?.numberInputRef.focus();
                }}
                color={"#BBBBBB"}
                width={4}
                bottom={30}
                left={90}
              >
                {props.value.length === 0 ||
                props.value.length <= dialCodeLength ? (
                  "123456789"
                ) : (
                  <Box>&nbsp;</Box>
                )}
              </Box>
            </Box>
    );
};

export default ModPhoneInput;